module.exports = __webpack_public_path__ + "img/right-round.aaa23505.png";